export default __webpack_public_path__ + "static/backgroundContact--blurH-3e50a2b414ab35c90438f54b6eb34154.jpg";